import { theme } from "@minted/minted-components";
import PropTypes from "prop-types";
import React from "react";

export const logoColors = {
  black: "black",
  dark: "dark",
  light: "light",
};

const colors = {
  black: theme.colors.black,
  dark: theme.colors.gray500,
  light: theme.colors.gray100,
};

const propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.keys(colors)),
  height: PropTypes.number,
  width: PropTypes.number,
};

const MintedWebsitesLogo = ({
  className = "",
  color = "dark",
  height = 20,
  width = 80,
}) => (
  <svg
    className={className}
    height={`${height}px`}
    version="1.1"
    viewBox="0 0 80 20"
    width={`${width}px`}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M2.48 8.14565H2.53333C3.25333 6.99933 4.54667 6.10924 5.94667 6.10924C7.62667 6.10924 8.84 6.97235 9.66667 8.41537C10.4667 7.0263 12 6.10924 13.6267 6.10924C17.0133 6.10924 17.8933 8.7795 17.8933 11.733V19.528H15.4133V12.151C15.4133 10.4788 15.1867 8.33446 13.0133 8.33446C10.3733 8.33446 10.1733 11.1126 10.1733 13.1221V19.528H7.70667V12.6231C7.70667 10.9238 7.62667 8.33446 5.33333 8.33446C2.69333 8.33446 2.46667 11.0856 2.46667 13.1221V19.528H0V6.50034H2.48V8.14565ZM21.0133 6.50034H23.4933V19.528H21.0133V6.50034ZM29.08 8.25354H29.1333C29.9067 6.86446 31.44 6.10924 33.0133 6.10924C36.6533 6.10924 37.5867 8.59069 37.5867 11.7599V19.528H35.1067V12.0701C35.1067 9.84491 34.8 8.33446 32.2667 8.33446C29.08 8.33446 29.08 11.18 29.08 13.5401V19.528H26.6V6.50034H29.08V8.25354ZM43.8 19.5415H41.32V8.84693H39.9467V6.51382H41.32V1.40256H43.8V6.51382H46.2267V8.84693H43.8V19.5415ZM49.5467 13.4322C49.5733 15.6575 51.0667 17.7478 53.4267 17.7478C55.32 17.7478 56.3467 16.7768 57.28 15.2124L59.3733 16.4127C58.16 18.6649 55.9067 19.973 53.4 19.973C49.4667 19.973 47.0667 16.9656 47.0667 13.1221C47.0667 9.11666 49.1867 6.10924 53.3467 6.10924C57.4533 6.10924 59.3733 9.1706 59.3733 13.0411V13.4322H49.5467ZM56.8933 11.5442C56.5867 9.58867 55.32 8.28051 53.3467 8.28051C51.4133 8.28051 49.9867 9.66959 49.68 11.5442H56.8933ZM71.7333 17.5051H71.68C70.6933 18.9751 69.12 19.9865 67.3067 19.9865C63.3467 19.9865 61.1467 16.6689 61.1467 12.9467C61.1467 9.38638 63.48 6.12272 67.2 6.12272C69.1333 6.12272 70.6667 7.1207 71.6933 8.6851H71.7467V0H74.2267V19.555H71.7333V17.5051ZM71.8667 13.0142C71.8667 10.4788 70.3467 8.33446 67.68 8.33446C65.12 8.33446 63.6 10.5866 63.6 13.0142C63.6 15.4686 65.0533 17.7478 67.68 17.7478C70.3867 17.7478 71.8667 15.5765 71.8667 13.0142ZM23.9467 2.40054C23.9467 3.35806 23.1867 4.12677 22.24 4.12677C21.2933 4.12677 20.5333 3.35806 20.5333 2.40054C20.5333 1.44302 21.2933 0.674309 22.24 0.674309C23.1867 0.674309 23.9467 1.44302 23.9467 2.40054ZM80 18.2738C80 19.2313 79.24 20 78.2933 20C77.3467 20 76.5867 19.2313 76.5867 18.2738C76.5867 17.3163 77.3467 16.5475 78.2933 16.5475C79.24 16.5475 80 17.3163 80 18.2738Z"
      fill={colors[color]}
    />
  </svg>
);

MintedWebsitesLogo.logoColors = logoColors;
MintedWebsitesLogo.propTypes = propTypes;

export default MintedWebsitesLogo;
